/**
 * Atella — Pack Price Localizer
 * -----------------------------
 * Replaces the contents of every <span class="atella-pack-price"> element
 * with the locally-relevant subscription entry price (Pack 1 = $39.95 USD base)
 * based on the customer's active currency.
 *
 * Where this is used:
 *   - Inside every product description's "Looking for the full set?" cross-link.
 *   - Anywhere else you place <span class="atella-pack-price">...</span>.
 *
 * To edit prices: just change the values in the PACK_PRICES object below.
 *
 * The script:
 *   1. Reads the active currency from Shopify.currency.active (set by Shopify
 *      when Markets / multiple currencies is enabled). Falls back to USD.
 *   2. Picks the matching string from PACK_PRICES.
 *   3. Swaps every .atella-pack-price element's text content.
 *   4. Re-runs on Shopify currency-change events (e.g. when the customer
 *      changes country in the country selector).
 */

(function () {
  'use strict';

  // === EDIT THESE TO MATCH YOUR SHOPIFY MARKETS PRICING ===
  // Keep them as STRINGS so you can format them with the right symbol/separators.
  // The key is the ISO 4217 currency code that Shopify will report.
  var PACK_PRICES = {
    USD: '$39.95',
    GBP: '£31.95',
    EUR: '€36.95',
    CAD: 'C$54.95',
    AUD: 'A$59.95',
    AED: 'د.إ 147',
    MXN: '$720 MXN',
    NOK: 'kr 425',
    CHF: 'CHF 35.95',
    THB: '฿1,400'
  };

  function getCurrency() {
    try {
      if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
        return window.Shopify.currency.active;
      }
    } catch (e) {}
    // Fallback: try meta tag (some themes set this)
    var meta = document.querySelector('meta[property="og:price:currency"]');
    if (meta) return meta.getAttribute('content');
    return 'USD';
  }

  function update() {
    var cur = getCurrency();
    var price = PACK_PRICES[cur] || PACK_PRICES.USD;
    var els = document.querySelectorAll('.atella-pack-price');
    for (var i = 0; i < els.length; i++) {
      els[i].textContent = price;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', update);
  } else {
    update();
  }

  // React to Shopify country/currency selector changes
  document.addEventListener('shopify:currency:change', update);
  document.addEventListener('currency:changed', update);
  // Country selector forms emit a submit/change before reload — handle just in case
  document.addEventListener('shopify:section:load', update);
})();
